import React from "react";
import {Box, Image} from "@chakra-ui/react";

// Shows photos at their natural aspect ratio in columns. onOpen(index) is called when a photo is clicked.
function PhotoMasonry({photos, alt, onOpen}) {
    const n = photos.length;
    return (
        <Box maxW={n === 1 ? "760px" : "none"}
             sx={{columnCount: {base: 1, sm: Math.min(2, n), lg: Math.min(3, n)}, columnGap: "16px"}}>
            {photos.map((src, index) => (
                <Box key={src} as="button" type="button" display="block" w="100%" mb={4} overflow="hidden" bg="ink.100"
                     sx={{breakInside: "avoid"}} onClick={() => onOpen(index)} aria-label={`Enlarge photo ${index + 1}`}>
                    <Image src={src} alt={alt} loading="lazy" w="100%" h="auto" display="block"
                           transition="transform 0.5s ease, opacity 0.2s" _hover={{transform: "scale(1.03)", opacity: 0.92}}/>
                </Box>
            ))}
        </Box>
    );
}

export default PhotoMasonry;
